(ns frontend.db
  (:require
   [reagent.core :as r]
   [reagent.ratom :as ratom]
   [common.util :as cu]
   [frontend.logging :as logging]
   [frontend.local-storage :as ls]
   [potpuri.core :refer [map-vals]]))

(defonce app-state
  (r/atom {:refresh-counter 0
           ;; A cursor is declared on `theme-id` in
           ;; frontend . ui . style . theme . core`
           :session         {:theme-id :base}
           :new-modals      {}}))
(defonce conn (r/cursor app-state [:conn]))
(defonce conn-state (r/cursor conn [:state]))
(defonce refresh-counter (r/cursor app-state [:refresh-counter]))
(defonce server-url (r/cursor app-state [:server-url]))
(defonce version (r/cursor app-state [:version]))
(defonce searching (r/cursor app-state [:searching]))
(defonce tracking-protection (r/cursor app-state [:tracking-protection]))
(defonce start-time (r/cursor app-state [:start-time]))
(defonce global-cursor (r/cursor app-state [:global-cursor]))
(defonce hide-modals (r/cursor app-state [:hide-modals]))
(defonce pipeline-drag (r/cursor app-state [:pipeline-drag]))
(defonce view (r/cursor app-state [:view]))
(defonce previous-view (r/cursor app-state [:previous-view]))
(defonce views (r/cursor app-state [:views]))
(defonce switching-tenant? (r/cursor app-state [:switching-tenant?]))
(defonce mobile (r/cursor app-state [:mobile]))
(defonce env (r/cursor app-state [:env]))
(defonce session (r/cursor app-state [:session]))
(defonce account-state (r/cursor session [:state]))
(defonce entities (r/cursor session [:entities]))

(defonce entity-types
  (ratom/reaction (->> @entities
                       vals
                       (group-by :entity/type))))
(defonce tenant (r/cursor session [:tenant]))
(defonce tenant-ecc (r/cursor tenant [:tenant-entity-creation-config]))
(defonce tenant-id (r/cursor tenant [:db/id]))
(defonce tenant-modules (r/cursor tenant [:tenant/modules]))
(defonce role (r/cursor session [:role]))
(defonce roles
  (ratom/reaction
   (:entity.type/role @entity-types)))

(defonce modals (r/cursor app-state [:new-modals]))
(defonce window (r/cursor app-state [:window]))
(defonce browser (r/cursor app-state [:browser]))

(defonce data-schema-version (r/cursor app-state [:data-schema-version]))
(defonce last-known-update (r/cursor app-state [:last-known-update]))

(defonce last-tenant-plan-ts (r/cursor app-state [:last-tenant-plan-ts]))

(defonce last-permissions-ts (r/cursor app-state [:last-permissions-ts]))

(defonce active-user-account-roles
  (ratom/reaction
   (some->> @roles
            (remove :common/disabled?)
            (cu/filter-by :role/target @tenant-id)
            (filter (fn [r]
                      (some #{(:role/role r)} [:role/user :role/admin])))
            (map (fn [r]
                   [(:role/subject r) (:role/role r)]))
            (into {}))))

(defn update-print-debug-to-worker!
  [print-debug?]
  (when-let [worker (:worker @app-state)]
    (.postMessage worker
                  (clj->js {:action       "toggle-debug-prints->worker"
                            :print-debug? print-debug?}))))

(defn toggle-debug!
  []
  (let [new-value (not (logging/print-debug?))]
    (logging/update-print-debug! new-value)
    (ls/set :print-debug? new-value)
    (update-print-debug-to-worker! new-value)))
